export default __webpack_public_path__ + "2df9e95b597b77fe4c8c6470a3dac665.svg";